export const analyticsPeriods = [
  { value: 7, label: "7 days" },
  { value: 30, label: "1 month" },
  { value: 90, label: "3 months" },
];

export function summarizePeriod(rows, getDate, days, now = new Date()) {
  const end = Number(now);
  const start = end - days * 86400000;
  const previousStart = start - days * 86400000;
  const current = [];
  let previous = 0;
  rows.forEach((row) => {
    const rawDate = getDate(row);
    if (!rawDate) return;
    const date = Number(new Date(rawDate));
    if (date >= start && date <= end) current.push(row);
    else if (date >= previousStart && date < start) previous += 1;
  });
  return {
    count: current.length,
    previous,
    recent: current.sort((a, b) => new Date(getDate(b)) - new Date(getDate(a))).slice(0, 4),
  };
}

export function calculatePercentageChange(current, previous) {
  if (previous === 0) return current > 0 ? null : 0;
  return Math.round(((current - previous) / previous) * 100);
}

export const getChangeDisplay = (value) => ({
  color: value > 0 ? "success" : value < 0 ? "error" : "text",
  label: value == null ? "N/A" : `${value > 0 ? "+" : ""}${value}%`,
});
